<template>
  <div class="aui-wrapper">
     <NavBar></NavBar>
     <RightSideBar></RightSideBar>
     <Search></Search>
      <div class="main-box">
        <router-view></router-view>
      </div>
  </div>
</template>

<script>
import NavBar from '@/views/modules/punchout/components/navBar'
import Search from '@/views/modules/punchout/components/search'
import RightSideBar from '@/views/modules/punchout/components/rightSideBar'
export default {
  name: 'punchoutMain',
  components: {
    NavBar,
    Search,
    RightSideBar
  },
  data () {
    return {

    }
  },
  computed: {},
  created () {

  },
  methods: {

  }
}
</script>

<style scoped lang='scss'>
body{
overflow-y: auto!important;;
}
.main-box{
  margin: 0 auto;
}
</style>
